import React,{useEffect, useState} from 'react'
import TableRows from "./TableRows"
import {FaPlusCircle} from 'react-icons/fa'
import {Button, Modal, Form,Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { SERVER_API } from '../../fileWithConstants';
import axios from 'axios'
import toast from 'react-hot-toast';
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
const AddDeleteTableRows= (props)=>{
    const [rowsData, setRowsData] = useState([{
      name:'',
      qty:'',
      unit:'Mtr',  
      price:'',  
      discount:0,
      amount:'',  
      gst:5  
  }]);
  const [dyeableValue, setDyeableValue] = useState('');
  const [category, setCategory] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('');
  const [option, setOption] = useState('');
  const [fbName, setFbName] = useState('');
  const [supFbName, setSupFbName] = useState('');
  const [validated, setValidated] = useState(false);
  const [addPrice, setAddPrice] = useState("");
  const [showAddFabric, setShowAddFabric] = useState(false);
  const [addQty, setAddQty] = useState("");
  const [supplierIdAdd, setSupplierIdAdd] = useState('');
    const [fabrics, setFabrics] = useState(props.fabrics);
    const [subtotal, setSubtotal] = useState(0); 
    const [gst, setGst] = useState(12); 
    const [totalAmount, setTotalAmount] = useState(0); 
    const [deliveryAdd, setDeliveryAdd] = useState("");
    const [delId, setDelId] = useState("");
    const [notes, setNotes] = useState("");
    const addTableRows = (e)=>{
      e.preventDefault();
        const rowsInput={
            name:'',
            qty:'',
            unit:'Mtr',  
            price:'',  
            discount:0,
            amount:'',  
            gst:5  
        } 
        setRowsData([...rowsData, rowsInput])
    }
   const deleteTableRows = (index)=>{
        const rows = [...rowsData];
        //console.log(rows)
        //console.log(index)
        rows.splice(index, 1);
        setRowsData(rows);
   }

    const handleClose = () => {
    setShowAddFabric(false);
  }

   useEffect(() => {
    setSupplierIdAdd(props.supplierId)
  }, [props.supplierId]);


  const getAllFabricCategory = async()=>{
    try {
      const {data} = await axios.get(`${SERVER_API}/api/v1/fabric/get-fabric-category`);
      if(data?.success){
        setCategory(data?.category)
      }
    } catch (error) {
      console.log(error)
    }
  }
  useEffect(()=>{
    getAllFabricCategory();
  },[])
  const handleFabricAdd = async(e)=>{
    const form = e.currentTarget;
    e.preventDefault();
   
    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
      return false;
    }
  
    try {
      const {data} = await axios.post(`${SERVER_API}/api/v1/fabric/add-fabric-from-list/`,{});
      
      if(data?.success){
        toast.success(data?.message)
        //setShowAddFabric(false);
        //getFabricData();
        /* navigate('/fabric-list') */
      }else{
        toast.error(data?.message)
      }
      //setSelectedParentId("");
    } catch (error) {
      console.log(error)
    }
  }

   
const handleChange = (index, evnt)=>{
  const { name, value } = evnt.target;
  const rowsInput = [...rowsData];

  /* if change fabric dropdown then fetch fabric details and set price */
  if(evnt.target.name=='name'){
    var fabric_id_price = evnt.target.value.split('#');
    rowsInput[index][name] = fabric_id_price[0];
    rowsInput[index]['price'] = fabric_id_price[1];
  }else{
    rowsInput[index][name] = value;
  }

  let amount_total = rowsInput[index]['qty']*rowsInput[index]['price'];
  let discount = rowsInput[index]['discount'];
  let discount_amount = ((amount_total*discount)/100);
  rowsInput[index]['amount'] = (amount_total-discount_amount);
  
  if(rowsInput.length>0){
     let price_arr = rowsInput.map(el=>el.amount); 
     let sum = price_arr.reduce((accumulator, currentvalue)=>{
        return accumulator+Number(currentvalue);
     },0)
    
    setSubtotal(sum);
    setTotalAmount(sum);
  }
  props.handleRowdata(rowsData);
  setRowsData(rowsInput);
}

useEffect(()=>{
  setFabrics(props.fabrics);
})

useEffect(()=>{
  handleAddress(0)
},[]);

useEffect(()=>{
  props.handlePodata({subtotal,gst,totalAmount,delId,deliveryAdd,notes});
},[subtotal,gst,totalAmount,deliveryAdd,notes])

const handleAddress = (addId)=>{
  setDelId(addId);
  let AddArr = [{"1":"A-14, Narayana \r industrial  area \r Delhi-110028","2":"A-44 Back side, Narayana \r industrial  area \r Delhi-110028"}];
  if(addId){
    const delAdd =AddArr[0][addId]; 
    setDeliveryAdd(delAdd);
  }else{
    setDeliveryAdd("");
  }
}

const handleAddFabric =(supplierIdAdd)=>{
  console.log('add fabric clicked==',supplierIdAdd)
  setShowAddFabric(true);
}


    return(
               <>
                <div className="row">
                <div className='col-md-12'>
                <div class="table-responsive-box box-table-responsive">
                  <table className="table table-hover table-sticky">
                      <thead>
                        <tr>
                          <th scope="col">Fabric {/* supplierIdAdd?<FaPlusCircle title="Add new fabric" onClick={()=>handleAddFabric(supplierIdAdd)}/>:'' */}</th>
                          <th scope="col" className='small-table-col'>Quantity</th>
                          <th scope="col" className='small-table-col'>Unit</th>
                          <th scope="col" className='medium-table-col'>Price</th>
                          <th scope="col" className='small-table-col'>Dis %</th>
                          <th scope="col" className='medium-table-col'>Amount INR</th>
                          <th scope="col" className='small-table-col'>GST %</th>
                          <th scope="col" className='medium-table-col'>Action</th>
                        </tr>
                      </thead>
                    <tbody>
                    <TableRows rowsData={rowsData} deleteTableRows={deleteTableRows} handleChange={handleChange} handleFabrics={fabrics}/>
                    </tbody> 
                  </table>
                  </div>
                  </div>
                  </div>

                  <div className="row bottom-divider">
                    <div className='col-md-4   mb-3'> 
                      <button className="btn btn-success" onClick={addTableRows} >+ Add Row</button>
                    </div>
                    <div className='col-md-8 float-end   mb-3'> 
                      <p>Subtotal: {subtotal}</p>
                      <p>GST: {gst}</p>
                      <p>Total: {totalAmount}</p>
                    </div>
                    </div>

                    <div className="row">
                    <div className='col-md-4 mb-3'>
                    <label className="form-label">Delivery Address*</label>
                    <select required className='form-control mb-3' name="del_id" onChange={(e)=>{handleAddress(e.target.value)}}>
                      <option value={""}>--Select Delivery Address--</option>
                      <option value={1}> A-14 </option>
                      <option value={2}> A-44 </option>
                    </select>

                    <textarea required cols={10} rows={3} style={{height:'85px'}} className='form-control' name='del_address'  value={deliveryAdd} onChange={(e)=>setDeliveryAdd(e.target.value)}/>
                    </div>

                    <div className='col-md-8 mb-3'>
                    <label className="form-label">Notes</label>
                    <textarea cols={15} rows={3} style={{height:"135px"}} className='form-control' name='po_notes' value={notes} onChange={(e)=>setNotes(e.target.value)}/>
                    </div>
                  </div>


                  <Modal show={showAddFabric} onHide={handleClose}>
                          <Modal.Header closeButton>
                            <Modal.Title>Add Fabric</Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                            <Form noValidate validated={validated} onSubmit={handleFabricAdd}>
                            <input type="hidden" name="supplierId" aria-label="Default select example" value={supplierIdAdd} />
                              
                            <Form.Group className="mb-3">
                                <Form.Label>Fabric Name (New)*:</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="fbName"
                                  placeholder="Fabric Name"
                                  onChange={(e)=>setFbName(e.target.value)}
                                  value={fbName}
                                  required
                                />
                              </Form.Group>
                            
                              <Form.Group className="mb-3">
                                <Form.Label>Fabric Name By Supplier:</Form.Label>
                                 <Form.Control
                                  type="text"
                                  name="supfbName"
                                  placeholder="Fabric Name By Supplier"
                                  onChange={(e)=>setSupFbName(e.target.value)}
                                  value={supFbName}
                                  required
                                />
                              </Form.Group>

                             <Form.Group className="mb-3">
                              <Form.Label>Choose Category*:{selectedCategory}</Form.Label>
                              <Typeahead
                                id="category-typeahead"
                                labelKey="name"
                                options={category}
                                placeholder="Choose a category"
                                selected={selectedCategory ? [category.find(c => c.id === selectedCategory)] : []}
                                onChange={(selected) => {
                                  if (selected.length > 0) {
                                    setSelectedCategory(selected[0].id);
                                  } else {
                                    setSelectedCategory('');
                                  }
                                }}
                                required
                                disabled={option}
                              />
                            </Form.Group>
                            
                            <Form.Group className="mb-3">
                                <Form.Label>Quantity (metres)*:</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="qty"
                                  placeholder="Quantity"
                                  onChange={(e)=>setAddQty(e.target.value)}
                                  value={addQty}
                                  controlId="validationCustom07"
                                  pattern="^-?[0-9]\d*\.?\d*$"
                                  required
                                />
                                <Form.Control.Feedback type="invalid">
                                Please provide a valid Quantity.
                              </Form.Control.Feedback>
                              </Form.Group>
                              
                              <Form.Group className="mb-3">
                                <Form.Label>Price/metre*:</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="price"
                                  placeholder="Price/metr"
                                  onChange={(e)=>setAddPrice(e.target.value)}
                                  value={addPrice}
                                  required
                                  controlId="validationCustom08"
                                  pattern="^-?[0-9]\d*\.?\d*$"
                                />
                                <Form.Control.Feedback type="invalid">
                                  Please provide a valid Price.
                                </Form.Control.Feedback>
                              </Form.Group>

                              

                              <Form.Group className="mb-3">
                                <Form.Label>Dyeable*:</Form.Label>
                                <Form.Select
                                  value={dyeableValue}
                                  required
                                  name="dyeable"
                                  onChange={(e) => setDyeableValue(e.target.value)}
                                >
                                  <option value="">--Select--</option>
                                  <option value="1">Yes</option>
                                  <option value="0">No</option>
                                </Form.Select>
                              </Form.Group>

                              <Form.Group className="mb-3">
                                <Form.Label>Picture Upload*:</Form.Label>
                                 <input className="form-control" required name='fabric_photo' type="file" accept="image/png, image/jpg, image/jpeg" />
                              </Form.Group>


                            <Button variant="success" type="submit">Add Fabric</Button>
                  
                            </Form>
                          </Modal.Body>
                  </Modal>

                  </>
                
           
    )
}
export default AddDeleteTableRows